import React from "react";

export const FormStep = ({ children, title }) => {
  return (
    <div className="w-full max-w-md mx-auto">
      <h2 className="text-xl font-semibold text-white mb-6 text-center">
        {title}
      </h2>
      {children}
    </div>
  );
};
